const ics = require('ics')

export default {
  name: 'agenda',

  isOpen: false,

  ui: {
    toggle: '[js-agenda-toggle]',
    dropdown: '[js-agenda-dropdown]',
    'ics[]': '[js-agenda-ics]',
    google: '[js-agenda-google]',
    yahoo: '[js-agenda-yahoo]',
  },

  events: [
    {
      on: 'click',
      target: 'toggle',
      handle () {
        this.isOpen = !this.isOpen

        this.ui.dropdown.classList.toggle('is-visible')
      },
    },
  ],

  formatDate (date, moment) {
    const d = new Date(date)
    const month = (d.getMonth() + 1)
    const day = d.getDate()
    const year = d.getFullYear()
    const hour = (moment === 'start') ? 8 : 20

    return [year, month, day, hour]
  },

  componentDidMount () {
    const startDateIcs = this.formatDate(this.props.startDate, 'start')
    const endDateIcs = this.props.endDate ? this.formatDate(this.props.endDate, 'end') : this.formatDate(this.props.startDate, 'end')

    ics.createEvent({
      title: this.props.title,
      start: startDateIcs,
      end: endDateIcs,
    }, (error, value) => {
      if (error) {
        console.log(error)
      }

      const data = new Blob([value], { type: 'text/calendar' })

      startDateIcs.pop()

      startDateIcs[1] = startDateIcs[1] < 10 ? `0${startDateIcs[1]}` : startDateIcs[1]
      const startDateLink = startDateIcs.join('')

      endDateIcs.pop()
      endDateIcs[1] = endDateIcs[1] < 10 ? `0${endDateIcs[1]}` : endDateIcs[1]
      const endDateLink = endDateIcs.join('')

      this.ui.google.href = `https://www.google.com/calendar/render?action=TEMPLATE&text=${this.props.title}&dates=${startDateLink}T060000Z/${endDateLink}T180000Z${this.props.location ? `&location=${this.props.location}` : ''}&sprop=&sprop=name:`
      this.ui.yahoo.href = `http://calendar.yahoo.com/?v=60&view=d&type=20&title=${this.props.title}&st=${startDateLink}T080000Z&et=${endDateLink}T200000Z${this.props.location ? `&in_loc=${this.props.location}` : ''}`

      this.ui.ics.forEach(link => {
        link.href = window.URL.createObjectURL(data)
      })
    })

    document.addEventListener('click', (e) => {
      if (!e.target.classList.contains('.calendar') && e.target.closest('.calendar') === null) {
        this.isOpen = false
        this.ui.dropdown.classList.remove('is-visible')
      }
    })
  },
}
